export const TocBiometricRoutes = (pathBase) => ({
    START_VALIDATION_PROCESS: `${pathBase}/validacion-biometrica/inicio-de-proceso`,
    VALIDATION_STATUS_QUERY: `${pathBase}/validacion-biometrica/consulta-de-estado`,
    VALIDATION_VIA_SDK: `${pathBase}/validacion-biometrica/validacion-via-sdk`,
  });